export default __webpack_public_path__ + "static/media/video_4.670722f8.mp4";